import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { SimIconModule } from '@simOn/ui/sim-icon';
import { AGENT_ACCESS_TEXTS, agentAccessMailto } from '../../model';

/**
 * Full-panel plate shown instead of the chat while the assistant is not enabled for the user: what the assistant
 * would do, a mail to the Simlab office and "Check again". There is nothing to read, so it replaces every view.
 */
@Component({
  selector: 'ai-agent-access-state',
  imports: [SimIconModule],
  templateUrl: './agent-access-state.component.html',
  styleUrl: './agent-access-state.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentAccessStateComponent {
  /** Office contact the mail goes to. */
  readonly contactEmail = input.required<string>();
  /** E-mail of the signed-in user; `null` hides the "Signed in as" line. */
  readonly userEmail = input<string | null>(null);
  /** The status is being fetched again. */
  readonly checking = input<boolean>(false);
  readonly checkAgain = output<void>();

  protected readonly texts = AGENT_ACCESS_TEXTS.notEnabled;
  protected readonly mailto = computed(() => agentAccessMailto(this.contactEmail(), this.texts));

  protected onCheckAgain(): void {
    this.checkAgain.emit();
  }
}
